<template>
  <div class="sub-page">
    <div class="main" v-if="teamRankList.length > 0">
      <div class="row row-title">
        <div class="col-1">排名</div>
        <div class="col-2">代表队</div>
        <div class="col-3">积分</div>
        <div class="col-4">胜场</div>
        <div class="col-5">负场</div>
        <div class="col-6">平场</div>
        <div class="col-7">胜率</div>
        <!--<div class="col-8"><div>近五场胜负</div></div> -->
      </div>
      <div class="row" v-for="(item, index) in teamRankList" :key="index" :class="index % 2 == 1? 'row-active' : ''">
        <div class="col-1">{{ index + 1 }}</div>
        <div class="col-2">{{ item.teamName }}</div>
        <div class="col-3">{{ item.score }}</div>
        <div class="col-4">{{ item.win }}</div>
        <div class="col-5">{{ item.fail }}</div>
        <div class="col-6">{{ item.draw }}</div>
        <div class="col-7">{{ winRate(item) }}</div>
        <!-- <div class="col-8">
          <div>W</div>
          <div>L</div>
          <div>W</div>
          <div>L</div>
          <div>W</div>
        </div> -->
      </div>
    </div>
    <AntdvEmpty v-else />
  </div>
</template>

<script>
import AntdvEmpty from '@comm/components/public/AntdvEmpty.vue'
export default {
  name: 'VolleyballTeam',
  props: {
    teamList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      teamParams: {
        matchId: this.$route.query.matchId,
      },
      teamRankList: [],
    }
  },
  components: { AntdvEmpty },
  mounted() {
    this.getFootballIntegralRank()
  },
  methods: {
    //计算胜率
    winRate(item) {
      let winRate =item.win&&(item.draw||item.fail)? ((item.win / (item.win + item.draw + item.fail)) * 100).toFixed(2) + '%':0+"%"
      return winRate
    },
    async getFootballIntegralRank() {
      try {
        let res = await this.$api.district.footballIntegralRank(this.teamParams)
        if (res.status == 0) {
          this.teamRankList = res.data
          this.total=res.total
        } else {
          this.message.error(res.msg)
        }
      } catch (error) {
        console.log(error)
      }
    },
  },
  computed: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.sub-page {
  padding-top: 30px;
  padding-bottom: 30px;
  background-color:#F7F7F7 ;
  .main {
    width: 1200px;
    margin: 0 auto;
    .row {
      font-weight: bold;
      font-size: 14px;
      display: flex;
      justify-content: flex-start;
      text-align: center;
      height: 60px;
      line-height: 60px;
      box-sizing: border-box;
      padding-left: 20px;
      .col-1 {
        width: 5%;
      }
      .col-2 {
        width: 25%;
      }
      .col-3 {
        width: 15%;
      }
      .col-4 {
        width: 15%;
      }
      .col-5 {
        width: 15%;
      }
      .col-6 {
        width: 15%;
      }
      .col-7 {
        width: 15%;
      }
      .col-8 {
        width: 25%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        div {
          width: 100%;
        }
      }
    }
    .row-title {
      font-size: 16px;
      font-weight: bold;
      background-color: #313131;
      border-radius: 10px 10px 0 0;
      color: #FFFFFF;
    }
    .row-active {
      background-color: #E9E9E9;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/comm/components/match/volleyball/components/VolleyballTeam.vue